import React from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';

import { MEDIA_QUERIES, PriceAmounts } from '@sm360/widget-commons-general';
import { LocaleService } from '@sm360/widget-commons-core-services';
import { PurchaseMethodsV25, CurrencyFormats } from '@sm360/widget-commons-vehicle';
import { CURRENCY_2 } from 'commons-vehicle/constants/currencyFormats.js';

import 'payment-calculator-v25/components/PaymentCalculatorDetails/components/CalculatorRebatesTradeIn/CalculatorRebatesTradeIn.scss';

class CalculatorRebatesTradeIn extends React.Component {
    constructor(props) {
        super(props);

        this.showRebateLabel = this.showRebateLabel.bind(this);
        this.showTradeInLabel = this.showTradeInLabel.bind(this);

        this.state = {
            showRebateLabel: false,
            showTradeInLabel: false,
        };
    }

    showRebateLabel() {
        this.setState((prevState) => {
            return { showRebateLabel: !prevState.showRebateLabel };
        });
        setTimeout(() => {
            this.setState({
                showRebateLabel: false,
            });
        }, 4000);
    }
    showTradeInLabel() {
        this.setState((prevState) => {
            return { showTradeInLabel: !prevState.showTradeInLabel };
        });
        setTimeout(() => {
            this.setState({
                showTradeInLabel: false,
            });
        }, 4000);
    }

    render() {
        const cashPurchaseSelected = this.props.purchaseMethods.isCashPurchase();
        const prices = this.props.purchaseMethods.getSelectedPurchaseMethodPaymentOption();
        const costOfCredit = prices?.term?.aprDetails?.totalCreditCost || '';

        const rebatesClassWrapper = ['paymentCalculator__rebates sr-paymentCalculator-background'];
        if (this.state.showRebateLabel) {
            rebatesClassWrapper.push('is-readable');
        }
        const tradeInClassWrapper = ['paymentCalculator__tradeIn sr-paymentCalculator-background'];
        if (this.state.showTradeInLabel) {
            tradeInClassWrapper.push('is-readable');
        }
        const rebates =
            prices?.incentives?.total > 0 ? (
                <div className={rebatesClassWrapper.join(' ')}>
                    <div className="paymentCalculator__rebates--term is-light " onClick={this.showRebateLabel}>
                        <icon className="icon-promo2 is-util" />
                        <MediaQuery minWidth={MEDIA_QUERIES.LAPTOP.MIN}>
                            <span>{LocaleService.t('PAYMENT_CALCULATOR_V25.CALCULATOR_REBATES_TRADEIN.REBATE')}</span>
                        </MediaQuery>
                        <MediaQuery maxWidth={MEDIA_QUERIES.MOBILE.MAX}>
                            <span>
                                {LocaleService.t('PAYMENT_CALCULATOR_V25.CALCULATOR_REBATES_TRADEIN.REBATE_MOBILE')}
                            </span>
                        </MediaQuery>

                        <PriceAmounts price={LocaleService.l(prices.incentives.total, CurrencyFormats.CURRENCY_2)} />
                    </div>
                </div>
            ) : null;

        const tradeIn =
            prices?.tradeIn > 0 && !cashPurchaseSelected ? (
                <div className={tradeInClassWrapper.join(' ')}>
                    <div className="paymentCalculator__tradeIn--term is-light" onClick={this.showTradeInLabel}>
                        <icon className="icon-refresh is-util" />

                        <MediaQuery minWidth={MEDIA_QUERIES.LAPTOP.MIN}>
                            <span>{LocaleService.t('PAYMENT_CALCULATOR_V25.CALCULATOR_REBATES_TRADEIN.TRADEIN')}</span>
                        </MediaQuery>
                        <MediaQuery maxWidth={MEDIA_QUERIES.MOBILE.MAX}>
                            <span>
                                {LocaleService.t('PAYMENT_CALCULATOR_V25.CALCULATOR_REBATES_TRADEIN.TRADEIN_MOBILE')}
                            </span>
                        </MediaQuery>
                        <PriceAmounts price={LocaleService.l(prices.tradeIn, CurrencyFormats.CURRENCY_2)} />
                    </div>
                </div>
            ) : null;
        if (tradeIn === null && rebates === null) {
            return null;
        }

        const paymentDetail = costOfCredit ? (
            <div className="paymentCalculator__tradeIn sr-paymentCalculator-background credit">
                <div className="paymentCalculator__rebates--term is-light">
                    <MediaQuery minWidth={MEDIA_QUERIES.LAPTOP.MIN}>
                        <span>{LocaleService.t('DOWN_PAYMENTS.TOTAL_CREDIT')}</span>
                    </MediaQuery>
                    <MediaQuery maxWidth={MEDIA_QUERIES.MOBILE.MAX}>
                        <span>{LocaleService.t('DOWN_PAYMENTS.TOTAL_CREDIT')}</span>
                    </MediaQuery>
                    <PriceAmounts price={LocaleService.l(costOfCredit, CURRENCY_2)} />
                </div>
            </div>
        ) : null;
        if (paymentDetail === null && rebates === null) {
            return null;
        }

        return (
            <div className="paymentCalculator__rebatesWrapper clearfix">
                {rebates}
                {tradeIn}
                {paymentDetail}
            </div>
        );
    }
}

CalculatorRebatesTradeIn.propTypes = {
    purchaseMethods: PropTypes.instanceOf(PurchaseMethodsV25.PurchaseMethodsModelV25).isRequired,
};

CalculatorRebatesTradeIn.displayName = 'CalculatorRebatesTradeIn';

export default CalculatorRebatesTradeIn;
